// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';
import { RunningLab, RunningLabStatus } from '../../types/Model';

import { RootAction, actionCreatorsList } from '../rootActionCreator';

export type RunningState = Partial<RunningLab>;

const {
  updateRunningChallengeAction,
  clearRunningChallengeAction,
} = actionCreatorsList;

export const initialState: RunningState = {
  status: RunningLabStatus.Stop,
};

function runningChallengeReducer(state = initialState, action: RootAction): RunningState {
  switch (action.type) {
    case getType(updateRunningChallengeAction): {
      if (action.payload.status === RunningLabStatus.Stop) {
        return {
          ...initialState
        }
      }

      return {
        ...state,
        ...action.payload,
      }
    }
    case getType(clearRunningChallengeAction): {
      return {
        ...initialState
      }
    }
    default: {
      return state;
    }
  }
}

export { runningChallengeReducer as default }
